import { asCreator, withCallbacks } from '../../../../lib/utils';
import { compose } from '../../../../utils/functions';
import { actionTypes } from '../../reducers/notificationsReducer';

export const confirmPendingHouseholdNotification = compose(
  withCallbacks,
  asCreator((args: any) => ({
    type: actionTypes.CONFIRM_PENDING_HOUSEHOLD,
    payload: args,
  }))
);
